// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
import * as cookies from "@kiwicom/cookies"
import { AuthToken } from "@kiwicom/nitro/lib/records/Auth"
import { remove as removeToken } from "@kiwicom/nitro/lib/services/auth/token"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any,no-underscore-dangle
const _store: Record<string, any> = {}

export default {
  add(id: number, token: string) {
    // called both simple_token and auth_token
    _store[id] = token
  },
  getSimple(id: number) {
    return _store[id]
  },
  remove(id: number) {
    if (id) {
      _store[id] = null
    }
    removeToken()
  },
}

export const getTokenAuth = (): AuthToken | null => {
  // nitro InitAuth cookie
  const simpleTokenCookie = cookies.load("simpleToken")

  if (simpleTokenCookie == null) {
    return null
  }

  try {
    const auth = JSON.parse(simpleTokenCookie)

    if (auth?.type === "token") {
      return auth
    }
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    // errors are ignored
  }

  return null
}
